import { ChannelMappingOptions } from 'api/integrations/slack/slack.types';

export const channelSettings = [
  {
    value: ChannelMappingOptions.NewChannel,
    key: ChannelMappingOptions.NewChannel,
  },
  {
    value: ChannelMappingOptions.FixedChannel,
    key: ChannelMappingOptions.FixedChannel,
  },
];
